module.exports = __webpack_public_path__ + "static/media/minivan_red.6ffe9583.svg";